import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getAllBonusStart } from '../../../../store/redux-slices/admins'
import { updateSABonusStatusStart } from '../../../../store/redux-slices/bonus'
import { safeStringify } from '../../../../utils/helpers'
import { useDidMountEffect } from '../../../../utils/useDidMountEffect'

const useBonus = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isInitialRender = useDidMountEffect()

  const { bonusList, loading } = useSelector((state) => state.admins)
  const [selectedClient, setSelectedClient] = useState('')
  const [selectedPortal, setSelectedPortal] = useState('')
  const [show, setShow] = useState(false)
  const [active, setActive] = useState('')
  const [bonusId, setBonusId] = useState(false)
  const [limit, setLimit] = useState(15)
  const [page, setPage] = useState(1)
  const [bonusTyp, setBonusTyp] = useState('')
  const [search, setSearch] = useState('')
  const [isActive, setIsActive] = useState('')
  const [name, setName] = useState()
  const [showGiveModal, setShowGiveModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showFreeSpinModal, setShowFreeSpinModal] = useState(false)
  const totalPages = Math.ceil(bonusList?.count / limit)

  const handleShow = (id, active, myName) => {
    setBonusId(id)
    setActive(!active)
    setShow(true)
    setName(myName)
  }

  const handleYes = () => {
    dispatch(
      updateSABonusStatusStart({
        data: {
          code: 'BONUS',
          status: active,
          bonusId
        },
        adminId: selectedClient,
        tenantId: selectedPortal,
        limit,
        pageNo: page,
        search,
        bonusType: bonusTyp === '' ? '' : safeStringify([bonusTyp]),
        isActive
      })
    )
    setShow(false)
  }

  useEffect(() => {
    !isInitialRender && dispatch(getAllBonusStart({
      adminId: selectedClient,
      tenantId: selectedPortal,
      limit,
      pageNo: page,
      search,
      bonusType: bonusTyp === '' ? '' : safeStringify([bonusTyp]),
      isActive
    }))
  }, [page])
  useEffect(() => {
    setPage(1)
    !showGiveModal && !showDeleteModal && !showFreeSpinModal &&
     dispatch(getAllBonusStart({
       adminId: selectedClient,
       tenantId: selectedPortal,
       limit,
       pageNo: 1,
       search,
       bonusType: bonusTyp === '' ? '' : safeStringify([bonusTyp]),
       isActive
     }))
  }, [selectedPortal, limit, bonusTyp, isActive, showGiveModal, showDeleteModal, showFreeSpinModal])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (page === 1) {
          dispatch(getAllBonusStart({
            adminId: selectedClient,
            tenantId: selectedPortal,
            limit,
            pageNo: page,
            search,
            bonusType: bonusTyp === '' ? '' : safeStringify([bonusTyp]),
            isActive
          })
          )
        } else {
          setPage(1)
        }
      }
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  return {
    navigate,
    loading,
    bonusList,
    selectedClient,
    selectedPortal,
    setSelectedPortal,
    setSelectedClient,
    handleShow,
    handleYes,
    show,
    setShow,
    active,
    limit,
    setLimit,
    setPage,
    page,
    totalPages,
    bonusTyp,
    setBonusTyp,
    search,
    setSearch,
    isActive,
    setIsActive,
    name,
    showGiveModal,
    setShowGiveModal,
    showDeleteModal,
    setShowDeleteModal,
    showFreeSpinModal,
    setShowFreeSpinModal
  }
}

export default useBonus
